<template lang="pug">
  .layout
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")
      v-card
        v-card-title.pa-2(style="background-color: var(--v-basic600T16)")
          v-row(no-gutters)
            v-col.shrink.mr-3
              v-btn.mr-n2(text icon @click="showModal = !showModal" height)
                eva-icon.ma-1(name="close" :fill="$vuetify.theme.themes[$theme].basic800" height="30")
            v-col.align-self-center
              p.mb-0.h6.basic800--text(v-if="note") {{ $t('edit') }} {{ $t('product_note') }}
              p.mb-0.h6.basic800--text(v-else) {{ $t('new') }} {{ $t('product_note') }}

        v-card-text.pa-0
          v-container.pa-0
            v-form(ref="form")
              v-card.pa-4(style="overflow-x: hidden; box-shadow:none")
                .note-title
                  div.mt-2.label.basic600--text.text-uppercase {{$t('note_title.label')}}
                  v-text-field.mt-2(v-model='form.name' :placeholder="$t('note_title.placeholder')" dense outlined height="40" background-color="basic200" :rules="rules.not_empty" hide-details="auto")
                
                .note-format.mt-4
                  div.label.basic600--text.text-uppercase {{$t('note_format.label')}}
                  v-select.mt-2(v-model="form.format" :items="fieldTypes" item-text="text" item-value="value" background-color="basic200" height="40" outlined dense hide-details="auto")
                    template(v-slot:append)
                      eva-icon(name="chevron-down-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
                
                .note-info.mt-4
                  div.label.basic600--text.text-uppercase {{$t('note_info.label')}}
                  v-text-field.mt-2(v-model='form.extra_info' :placeholder="$t('note_info.placeholder')" dense outlined height="40" background-color="basic200" hide-details="auto")

                y-checkbox.my-auto.mt-6.mx-2(v-model="form.required" hide-details)
                  template(v-slot:label)
                    div.p1.my-auto {{ $t('require_to_fill') }}
                
                template(v-if="!product")
                  div.d-flex.align-center.mt-4
                    p.h6.basic1000--text.mb-0 {{ $t('assign_to_product') }}
                    v-spacer
                    v-btn.button-AA-tiny(color="textColorAccent" outlined x-small height="24" :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}" @click='showAttachProductsDialog = true')
                      v-icon.mr-1(small) mdi-plus
                      | {{ $t('product') }}
                  
                  .attach-product.mt-4
                    v-select.my-2(v-model="products" background-color="basic200" outlined dense hide-no-data chips hide-details multiple readonly :items="products" :menu-props="({'closeOnContentClick': false})" placeholder="Select product to assign" :loading="productSearchLoading" ref="selectProducts" type="button" append-icon="")
                      template(v-slot:selection="{ attrs, item, select, selected }")
                        v-chip.my-1.s2(outlined :style="`background-color: ${$vuetify.theme.themes[$theme].basic600T08}`" close-icon="mdi-close" v-bind="attrs" small close :color="item.status === 'draft' ? 'danger' : 'basic600'" :input-value="selected" @click:close="removeProd(item)")
                          span(v-if="item.name") {{ item.name.length > 25 ? (item.name.substr(0,25) + '...') : item.name }}{{ item.status === 'draft' ? ' (draft)' : '' }}

        v-card-actions.pa-2.pb-4
          v-spacer
          v-btn(text @click='showModal = false' depressed height=32 )
            .button-Aa-small.primary400--text| {{ $t('cancel') }}
          v-btn.mr-2(color='textColorAccent' depressed height=32 @click="clickSave" :loading="isLoading")
            .button-AA-small.basic100--text
              span(v-if="note") {{ $t('save') }}
              span(v-else) {{ $t('create') }}
    
    .modals
      attach-products(v-if="showAttachProductsDialog" :open.sync="showAttachProductsDialog" :initialProducts.sync="products" title="Assign to products" excludeBundles)

</template>

<script>
import { mapActions } from 'vuex'
import AttachProducts from '@/components/dialogs/AttachProducts.vue'

let asyncForEach = async function(array, callback) {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array)
  }
}
export default {
  name: 'AddProductNotesDialog',
  props: ['open', 'parentNote', 'company', 'product'],
  components: { AttachProducts },
  data: (v) => ({
    form: v.parentNote || {
      id: null,
      company: v.company.id,
      name: '',
      format: 'long_text',
      extra_info: '',
      required: false,
      product_count: 0
    },
    productSearchLoading: false,
    showAttachProductsDialog: false,
    fieldTypes: [
      { 
        text: 'Long text',
        value: 'long_text'
      },
      { 
        text: 'Short text',
        value: 'short_text'
      },
      { 
        text: 'Numbers',
        value: 'number'
      }
    ],
    products: [],
    originalProducts: [],
    successMessage: '',
    loadSaveProduct: false,
    loadSaveVariants: false,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      number_not_empty: [v => v !== null || 'This field is required'],
      is_selected: [(v) => v !== null || 'This field is required'],
      has_quantity: [(v) => !!v || 'This field is required', (v) => v != 0|| 'This field is required'],
      has_items: [(v) => !!v || 'This field is required']
    },
  }),
  computed: {
    note: {
      get() {
        return this.parentNote
      },
      set(newValue) {
        this.$emit('update:parentNote', newValue)
      }
    },
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    isLoading () {
      if (this.loadSaveProduct || this.loadSaveVariants) {
        return true
      }
      return false
    }
  },
  mounted () {
    if (this.note && this.note.id) {
      this.productSearchLoading = true
      this.$axios.get(`/product_notes/${this.note.id}/products`)
        .then((response) => {
          this.products = response.data.results
          this.originalProducts = [...response.data.results]
        })
        .catch(() => {})
        .finally(() => {
          this.productSearchLoading = false
        })
    }
    if (this.product && this.product.id) {
      this.products.push(this.product)
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    clickSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.loadSaveProduct = true
      if (this.form.id) {
        this.axios.patch(`/product_notes/${this.form.id}/`, this.form)
          .then(resp => {
            this.successMessage = 'Note edited'
            this.saveProducts(resp.data)
            this.$emit('update:note', resp.data)
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
          .finally(() => {
            this.loadSaveProduct = false
          })
          return
      }
      this.axios.post(`/product_notes/`, this.form)
        .then(resp => {
          this.successMessage = 'Note added'
          this.saveProducts(resp.data)
          this.$emit('added', resp.data)
        })
        .catch(e => {
          if (e.response && e.response.data && e.response.data.non_field_errors && e.response.data.non_field_errors.length > 0) {
            this.showMessage(['error', e.response.data.non_field_errors[0]])
          } else {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          }
        })
        .finally(() => {
          this.loadSaveProduct = false
        })
    },
    async saveProducts (note) {
      this.loadSaveVariants = true
      let count = 0
      await asyncForEach(this.products, async (product) => {
        if (this.originalProducts.map(p => (p.id)).includes(product.id)) {
          this.originalProducts = this.originalProducts.filter((x) => x.id !== product.id)
        } else {
          await this.axios.post(`/product_notes/${note.id}/products`, {
            single_id: product.id
          })
        }
        count++
      })
      await asyncForEach(this.originalProducts, async (deleted) => {
        await this.axios.delete(`/product_notes/${note.id}/products/${deleted.id}/`)
      })
      this.loadSaveVariants = false
      this.showMessage(['success', this.successMessage])
      this.$set(this.note, 'product_count', count)
      this.showModal = false
    },
    removeProd (item) {
      let index = this.products.map(m => { return m.id}).indexOf(item.id)
      if (index >= 0) this.products.splice(index, 1)
      this.$refs.selectProducts.isMenuActive = false
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "note_title": {
      "label": "Note title*",
      "placeholder": "e.g. Message on card"
    },
    "note_format": {
      "label": "format*",
      "placeholder": "Select note format"
    },
    "note_info": {
      "label": "Extra info",
      "placeholder": "Any instructions or disclaimers"
    },
    "product_note": "product note",
    "require_to_fill": "Require customers to fill this field",
    "assign_,to_product": "Assign to product"
  },
  "id": {
    "note_title": {
      "label": "Judul Notae*",
      "placeholder": "e.g. Pesan di kartu"
    },
    "note_format": {
      "label": "format*",
      "placeholder": "pilih format pesan"
    },
    "note_info": {
      "label": "info tambahan",
      "placeholder": "jika ada pesan tambahan atau disklamer"
    },
    "product_note": "nota product",
    "require_to_fill": "Wajibkan pelanggan mengisi nota",
    "assign_to_product": "Tetapkan ke produk"
  }
}
</i18n>